import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  useEffect(() => {
    // Ensure scroll to top when component mounts (page transition starts)
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <motion.div
      {...({
        // IMPORTANT: initial={false} ensures the component renders immediately visible
        // This fixes the "white screen" issue in Google Search Console snapshots
        initial: false,
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.3, ease: 'easeInOut' },
        className: 'w-full h-full',
      } as any)}
    >
      {children}
    </motion.div>
  );
};
